import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reducer from '../reducer/slice';
import StateManager from '../../utils/StateManager';

const rootReducer = combineReducers({
  app: reducer,
});
const stateLoader = new StateManager();
const store = configureStore({
  reducer: rootReducer,
  preloadedState: stateLoader.loadState(),
});
store.subscribe(() => {
  stateLoader.saveState(store.getState());
});
export default store;
